import { Component, DestroyRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { TabDirective, TabsetComponent } from 'ngx-bootstrap/tabs';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { ICarpetaTributariaElectronicaReporteModel } from 'src/app/models/reporte-full/reporte-full.model';
import { AlertService } from 'src/app/components/_alert/alert.service';
import { ModalCarpetaService } from 'src/app/shared/services/modal-carpeta.service';
import { UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { ReporteFullService } from 'src/app/shared/services/reporte-full.service';
import { UtilsService } from 'src/app/shared/services/utils.service';
import { rutValidate } from 'rut-helpers';
import { UsuariosService } from 'src/app/shared/services/usuarios.service';
import { AsincronoService } from 'src/app/shared/services/asincrono.service';
import * as uuid from 'uuid';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

interface Reporte {
  reporte: string;
  idTransaccion: string;
}

@Component({
  selector: 'app-modal-consultar-carpeta-tributaria',
  templateUrl: './modal-consultar-carpeta-tributaria.component.html',
  styleUrls: ['./modal-consultar-carpeta-tributaria.component.scss']
})
export class ModalConsultarCarpetaTributariaComponent implements OnInit {
  @ViewChild('tabsRef', { static: false }) tabsRef?: TabsetComponent;
  @Input() rut: string | any;
  @Input() alertSuccess: boolean = false;
  @Input() alertError: boolean = false;
  @Input() idsReportes: Reporte[] = [];
  private subscriptions: Subscription[] = [];
  public activateRutHelper = false;
  public activateRutHelperEjecutivo = false;
  public reportFullFormSend!: FormGroup;
  public valueTab: string | undefined = 'Procesar';
  public tempFile: any;
  public today: string = '';
  public mensajeError: string = 'Se ha producido un error';
  public showFormDescarga: boolean = false;
  @Output() reporteFullContent = new EventEmitter<ICarpetaTributariaElectronicaReporteModel>();
  @Output() service = new EventEmitter<string>();
  @Output() cteAsync = new EventEmitter<any>();

  constructor(
    private modalService: ModalCarpetaService,
    private spinner: NgxSpinnerService,
    public alertService: AlertService,
    private fb: UntypedFormBuilder,
    private reporteFullService: ReporteFullService,
    private utilsService: UtilsService,
    private usuariosService: UsuariosService,
    private asyncService: AsincronoService,
    private destroyRef: DestroyRef
  ) {
  }
  
  ngOnInit() {
    this.initForm();
  }

  close() {
    this.valueTab = 'Procesar';
    this.initForm();
    this.modalService.close();
  }

  validaEstado(): boolean{
    const estado = this.modalService.watch();
    if(!estado){
      this.Limpiar();
    } 
    return estado;
  }

  initForm(): void {
    this.alertSuccess = false;
    this.alertError = false;
    this.mensajeError = 'Se ha producido un error';
    this.reportFullFormSend = this.fb.group({});
    const form = this.reportFullFormSend;

    this.valueTab === 'Procesar' ?
      (form.addControl('pdf', new UntypedFormControl('', [Validators.required])),
        form.addControl('validar', new UntypedFormControl(true, [Validators.required])))
      : this.valueTab === 'Crear' ?
        (form.addControl('email', new UntypedFormControl('', [Validators.required, Validators.email])),
        form.addControl('claveSii', new UntypedFormControl('', [Validators.required]))) :
        ( // Descargar
          form.addControl('codigoCte', new UntypedFormControl('', [Validators.required])),
          form.addControl('claveCte', new UntypedFormControl('', [Validators.required])),
          form.addControl('rutReceptor', new UntypedFormControl('', [Validators.required])),
          form.addControl('claveReceptor', new UntypedFormControl('', [Validators.required]))
        )

    if(this.valueTab === 'Descargar') 
      this.showFormDescarga = true;

    if(this.reportFullFormSend?.get('validar')?.value == true && this.valueTab === 'Procesar')
      this.logicaDatosEjecutivo(true)

    this.onChangesValidar();
    this.onChangesRutEjecutivo();
    this.onChangesReceptor();
  }

  onSelect(data: TabDirective): void {
    this.valueTab = data.heading;
    this.tempFile = null;
    if(this.valueTab === 'Descargar') {
      this.showFormDescarga = false;
    }
    this.initForm();
  }

  onChangesReceptor(): void {
    this.subscriptions.forEach(subscription => {
      subscription.unsubscribe();
    });

    this.subscriptions = [];
    this.activateRutHelper = false;

    const rutReceptorCtrl = this.reportFullFormSend.get('rutReceptor');
    if (!rutReceptorCtrl) return;

    this.subscriptions.push(rutReceptorCtrl.valueChanges.subscribe(val => {
      this.activateRutHelper = rutValidate(val) ? false : true;
    }));
  }

  clearControl(controlName: string): void {
    this.reportFullFormSend?.get(controlName)?.reset();
    this.reportFullFormSend?.get(controlName)?.markAsUntouched();
  }
  
  submit() {
    this.alertSuccess = false;
    this.alertError = false;
    this.mensajeError = 'Se ha producido un error';

    if (this.valueTab === 'Procesar' && this.reportFullFormSend?.get('validar')?.value == true) {
      if(!this.reportFullFormSend?.get('rutSii')?.value && !this.reportFullFormSend?.get('claveSii')?.value) {
        // si esta uno de los dos invalid o touched se deben resetear
        this.clearControl('rutSii');
        this.clearControl('claveSii');
        this.reportFullFormSend?.get('rutSii')?.setValue('');
        this.reportFullFormSend?.get('claveSii')?.setValue('');
        this.reportFullFormSend?.get('rutSii')?.setErrors(null);
        this.reportFullFormSend?.get('claveSii')?.setErrors(null);
      }
    }

    if(this.activateRutHelperEjecutivo == true && this.valueTab === 'Procesar') {
      return;
    }

    if (!this.reportFullFormSend.valid) {
      this.utilsService.validateAllFormFields(this.reportFullFormSend);
      return;
    }
    const form = this.reportFullFormSend.getRawValue();
    const service = this.valueTab === 'Procesar' ? 'procesarReport' :
      this.valueTab === 'Crear' ? 'createReport' : 'descargarReport';

    let validar: boolean = true;
    if (this.valueTab === 'Procesar') {
      form.pdf = this.tempFile;
      validar = form.validar;
      if(form.validar == true) {
        if((form.rutSii && !form.claveSii) || (!form.rutSii && form.claveSii)) {
          this.alertSuccess = false;
          this.alertError = true;
          this.mensajeError = 'Ingrese correctamente las credenciales';
          return;
        }
        form.rutSii = this.utilsService.formatterRutV2(form.rutSii);
      }
    } else if(this.valueTab === 'Descargar') {
      form.rutReceptor = this.utilsService.formatterRutV2(form.rutReceptor);
    }

    this.spinner.show();
    this.reporteFullService[service](this.rut, form, validar).subscribe(
      (response: any) => {
        this.spinner.hide();
        const trx = response?.CarpetaTributariaElectronicaReporte?.DatosBasicosSolicitud?.IDTransaccion;

        if (Object.keys(response).length <= 0) {
          this.alertSuccess = false;
          this.alertError = true;
          this.mensajeError = 'Se han detectado errores en el procesamiento de la Carpeta Tributaria solicitada.';
          this.service.emit('reporteFinanciero');
        }

        if(!trx) {console.error('Ocurrio un problema al obtener la transacción'); return}

        const message = response?.CarpetaTributariaElectronicaReporte?.DatosBasicosSolicitud;

        if (message && message?.EstadoTransaccion === 'COMPLETED' && message?.SubEstadoTransaccion === 'COMPLETED-CALCULATED') {
          this.alertSuccess = true;
          this.alertError = false;
          this.reporteFullContent.emit(response);
        } else if (message && (message?.EstadoTransaccion === 'ERROR' || message?.SubEstadoTransaccion === 'ERROR')) {
          this.alertSuccess = false;
          this.alertError = true;
          this.mensajeError = `Ocurrio un problema al ${this.valueTab === 'Crear' ? 'crear' : 'procesar'} el reporte`;
          this.service.emit('reporteFinanciero');
        } else if(message && message?.EstadoTransaccion === 'COMPLETED') {
          this.obtenerInformeCompleto(trx); // calculo de ventas
        } else if (message && message?.EstadoTransaccion === 'IN-PROGRESS') {
          this.alertService.warn(`Se esta ejecutando ${this.valueTab === 'Crear' ? 'la creación' : 'el procesamiento'} del reporte carpeta tributaria, cuando este finalizado se le notificará.`);
          const idUnico = uuid.v4();
          this.idsReportes = this.addReporteFinancieroID(trx, this.idsReportes);
          this.cteAsync.emit({listReportes: this.idsReportes, idUnico: idUnico});
          this.asyncService.llamadaCreacionCTE(trx, this.rut, '/reporte-consolidado/consultar', idUnico, this.idsReportes);
          window.scroll({ top: 0, left: 0, behavior: 'smooth' }); // scroll up
          this.close();
        } else {
          console.error("Ha ocurrido un error validando los estados del reporte")
        }
      },
      (error: any) => {
        this.spinner.hide();
        this.alertSuccess = false;
        this.alertError = true;
        this.mensajeError = (error.error.message || 'Ocurrio un problema');
      }
    );
  }

  addReporteFinancieroID(id: string, idsArray: any[]): any[] {
    const index = idsArray.findIndex(e => e.reporte === 'reporteFinanciero');
    if(index >= 0) {
      idsArray[index].idTransaccion = id;
    } else {
      idsArray.push({reporte: 'reporteFinanciero', idTransaccion : id})
    }

    return idsArray;
  }

  obtenerInformeCompleto(trx: string) {
    this.spinner.show();
    this.reporteFullService.calcularVentas(this.rut, trx).subscribe(
      (response: ICarpetaTributariaElectronicaReporteModel) => {
        
        if (Object.keys(response).length > 0) {
          this.alertSuccess = true;
          this.alertError = false;
          this.reporteFullContent.emit(response);
        } else {
          this.alertSuccess = false;
          this.alertError = true;
          this.mensajeError = 'Se han detectado errores en el procesamiento de la Carpeta Tributaria solicitada.';
          this.service.emit('reporteFinanciero');
        }
        this.spinner.hide();
      },
      (error: any) => {
        this.alertSuccess = false;
        this.alertError = true;
        this.spinner.hide();
        this.mensajeError  = (error.error.message || 'Ocurrio un problema');
        this.service.emit('reporteFinanciero');
      }
    );
  }

  handleUpload(event: any) {
    const file = event.target.files[0];
    if (file && file.size <= 5242880) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.tempFile = reader?.result?.toString().split(',')[1];
      };
      this.alertSuccess = false;
      this.alertError = false;
      this.mensajeError = 'Se ha producido un error';
    } else if (file) {
      this.tempFile = null;
      this.reportFullFormSend?.get('pdf')?.setValue('');
      this.alertSuccess = false;
      this.alertError = true;
      this.mensajeError  = (`El tamaño máximo del archivo debe ser de 5mb`);
    }
  }

  Limpiar(): void {
    this.reportFullFormSend.reset();
    this.reportFullFormSend?.get('validar')?.setValue(true);
    if(this.reportFullFormSend?.get('validar')?.value == true) {
      this.logicaDatosEjecutivo(true)
    }
    this.activateRutHelper = false;
    this.activateRutHelperEjecutivo = false;
    this.alertSuccess = false;
    this.alertError = false;
    this.mensajeError = 'Se ha producido un error';
  }

  onChangesRutEjecutivo(): void {
    this.reportFullFormSend?.get('rutSii')?.valueChanges
    .pipe(
      takeUntilDestroyed(this.destroyRef)
    )
    .subscribe((value: any) => {
      //this.logicaDatosEjecutivo(value);
      if(value) {
        this.activateRutHelperEjecutivo = rutValidate(value) ? false : true;
      } else {
        this.activateRutHelperEjecutivo = false;
      }
    });
    //rutSii
  }

  onChangesValidar(): void {
    this.reportFullFormSend?.get('validar')?.valueChanges
    .pipe(
      takeUntilDestroyed(this.destroyRef)
    )
    .subscribe((value: boolean) => {
      this.logicaDatosEjecutivo(value);
    });
  }

  logicaDatosEjecutivo(value: boolean): void {
    if (value == true) {
      if (!this.reportFullFormSend?.contains('rutSii')) {
        this.reportFullFormSend?.addControl('rutSii', new UntypedFormControl(''));//, gtpRutValidator()
      } else {
        this.reportFullFormSend?.get('rutSii')?.setValue('');
      }
      if (!this.reportFullFormSend?.contains('claveSii')) {
        this.reportFullFormSend?.addControl('claveSii', new UntypedFormControl(''));
      } else {
        this.reportFullFormSend?.get('claveSii')?.setValue('');
      }
    } else if(value == false) {
      if (this.reportFullFormSend?.contains('rutSii')) {
        this.reportFullFormSend?.removeControl('rutSii');
      }
      if (this.reportFullFormSend?.contains('claveSii')) {
        this.reportFullFormSend?.removeControl('claveSii');
      }
    }
  }

  mostrarEntradaEjecutivos(): boolean {
    if(this.valueTab === 'Procesar' && this.reportFullFormSend?.get('validar')?.value == true && this.reportFullFormSend?.contains('rutSii') && this.reportFullFormSend?.contains('claveSii')) {
      return true;
    }
    return false;
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => {
      subscription.unsubscribe();
    });
    this.alertSuccess = false;
    this.alertError = false;
    this.mensajeError = 'Se ha producido un error';
  }

}
